import { AxiosInstance, AxiosResponse } from 'axios';

export type PushNotificationsApi = ReturnType<typeof getPushNotificationsApi>;

export const getPushNotificationsApi = (axiosInstance: AxiosInstance) => {
  const setExpoPushToken = async (userId: string, expoPushToken: string): Promise<void> =>
    axiosInstance
      .post<{ expoPushToken: string }, AxiosResponse<void>>(
        `/push-notifications/users/${userId}/tokens`,
        {
          pushToken: expoPushToken,
        }
      )
      .then(() => {});

  const disablePushNotifications = async (userId: string, expoPushToken: string): Promise<void> =>
    axiosInstance.post(`/push-notifications/users/${userId}/tokens/delete`, {
      pushToken: expoPushToken,
    });

  return {
    setExpoPushToken,
    disablePushNotifications,
  };
};
